<template>
  <a-card>
    <div>
      <a-page-header
        style="border: 1px solid rgb(235, 237, 240)"
        title="模板"
        @back="handleGoBack"
      >
      </a-page-header>
      <a-row>
        <a-col span="8"></a-col>
      </a-row>
      <div v-html="content">
      </div>
    </div>
  </a-card>
</template>

<script>
import { trade_custom_reminder_template_read, trade_custom_reminder_template_list } from '@/api/trade_custom_reminder'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      content: null
    }
  },
  // beforeCreate () {
  //   this.form = this.$form.createForm(this)
  // },
  mounted () {
    this.$nextTick(() => {
      trade_custom_reminder_template_list({ id: this.$route.params.id })
        .then(({ data }) => {
          console.log(data, '我是数据列表@')
          const entries = data.entries
          if (entries && entries.length > 0) {
            this.loadEditInfo(entries[0])
          }
        })
    })
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadEditInfo (data) {
      trade_custom_reminder_template_read(data.id).then(({ data }) => {
       console.log(data, '我是模板')
        this.content = data.content
      })
    }
  }
}
</script>
